import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { AgendamentoDespesa } from 'src/app/admihair/api/dto/agendamento-despesa';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Fornecedor } from 'src/app/admihair/api/dto/fornecedor';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { AgendamentoDespesaService } from 'src/app/admihair/service/agendamento-despesa.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FornecedorService } from 'src/app/admihair/service/fornecedor.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-agendamento-despesa-inserir',
  templateUrl: './agendamento-despesa-inserir.component.html',
  styleUrls: ['./agendamento-despesa-inserir.component.scss']
})
export class AgendamentoDespesaInserirComponent implements OnInit {
  
  permissaoInserir: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  empresaSelecionada?: Empresa;
  planosContaEmpresa: PlanoContaEmpresa[] = [];
  parcelaInicial: number = 1;
  fornecedores: Fornecedor[] =[];
  contaSelecionada?: PlanoContaEmpresa;
  agendamento: boolean = false;
  tiposPagamento: TipoPagamento[] = [];
  dataAtual: Date = new Date();
  @ViewChild('f') form?: NgForm;

  constructor(
    private agendamentoDespesaService: AgendamentoDespesaService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private fornecedorService: FornecedorService,
    private tipoPagamentoService: TipoPagamentoService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_AGENDAMENTO_DESPESA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoInserir) {
      this.buscarContas();
      this.buscarFornecedores();
    }
  }

  salvar(){
    this.progressoRequisicao = true;
    const agendamentoDespesa: AgendamentoDespesa = this.form?.value;
    agendamentoDespesa.empresaId = this.empresaSelecionada?.id
    agendamentoDespesa.profissionalId = 0;
    if(this.agendamento) {
      agendamentoDespesa.status = 2;
    } else {
      agendamentoDespesa.status = 0;
    }
    agendamentoDespesa.operador = this.utilStorageService.getUser().usuario.id;
    
    this.agendamentoDespesaService.salvar(agendamentoDespesa).subscribe({
      next: (data: AgendamentoDespesa[]) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
        this.limparFormulario();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }
    });
    
  }

  buscarFornecedores(){
    this.fornecedorService.listarPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Fornecedor[]) => {
        this.fornecedores = data;
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  buscarContas(){
    const utilizacoes: string[] = ['DESPESA', 'FOLHA/DESPESA'];
    this.planoContaEmpresaService.listarPorEmpresaEUtilizacao(this.empresaSelecionada?.id, utilizacoes)
      .subscribe({
        next: (data: PlanoContaEmpresa[]) => {
          this.planosContaEmpresa = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      })
  }

  selecionarAgendamento(){
    if(this.agendamento){
      this.carregarTiposPagamento();
    }
  }

  carregarTiposPagamento(){
    this.tipoPagamentoService.listarPorEmpresaEOperacaoDespesa(this.empresaSelecionada?.id)
      .subscribe({
        next: (data: TipoPagamento[]) => {
          this.tiposPagamento = data;
        },
        error: (err: any) => {
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      })
  }
  

  verificarContaFornecedor(id: number): boolean{
    const plano = this.planosContaEmpresa.find(p => p.id === id);
    return plano ? plano.codigo === 22 : false;
  }

  verificarValorParcela(valor: any){
    return valor > 0 ? true : false;
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  limparFormulario(){
    this.form?.reset(); 
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
}
